export const getParams = ({srpInitData, properties, searchName = "", pathname}) => {
  const {
    propertySubType,
    category,
    propertyStatus,
    occupancyStatus,
    sid,
    propertyShowMoreStatus,
    listingType,
    newToHubzu,
    marketingPhase,
    auctionEndingToday,
    ownItNow,
    nobuyerpremium,
    brokerCoOp,
    cashOnly,
    bedrooms,
    bathrooms,
    price,
    area,
    builtYear,
  } = properties;
  const param = new FormData();
  param.append("searchBy", srpInitData?.searchBy || "All States");
  param.append("state", srpInitData?.state || "");
  param.append("zip", srpInitData?.zip || "");
  param.append("polygonId", srpInitData?.polygonId);
  param.append("polygonType", srpInitData?.polygonType);
  param.append("sortBy", srpInitData?.sortBy === "default" ? "" : srpInitData?.sortBy);
  param.append("minPriceValue", [`${price.min === 0 ? '' : price.min || ''}`]);
  if ((price.min || price.max) && !((price.min === '0' || price.min === 0) && (price.max === 1000001 || price.max === 0))) {
    param.append("maxPriceValue", [`${price.max === 1000001 ? "" : price.max}`]);
  }
  param.append("propertySubType", propertySubType.length > 0 ? propertySubType : "");
  if (bedrooms) {
    param.append("minBedroomCount", [bedrooms]);
  }
  if (bathrooms) {
    param.append("minBathroomCount", [bathrooms]);
  }
  if ((area.min || area.max) && !((area.min === '0' || area.min === 0) && (area.max === 10001 || area.max === 0))) {
    param.append("minPropertySize", [`${area.min || ''}`]);
  }
  if ((area.min || area.max) && !((area.min === '0' || area.min === 0) && (area.max === 10001 && area.max === 0))) {
    area.max !== 10001 && param.append("maxPropertySize", [`${area.max}`]);
  }
  if ((builtYear.min) && !((builtYear.min === 1799 || builtYear.min === 0 || builtYear.min === '0') && (builtYear.max === 2011 || builtYear.max === 0 || builtYear.max === '0'))) {
    param.append("minYearBuilt", [`${builtYear.min || ""}`]);
  }
  if ((builtYear.min || builtYear.max) && !((builtYear.min === 1799 || builtYear.min === 0 || builtYear.min === '0') && (builtYear.max === 2011 || builtYear.max === 0 || builtYear.max === '0'))) {
    builtYear.max !== "After 2010" && builtYear.max !== 2011 && param.append("maxYearBuilt", [`${builtYear.max}`]);
  }
  if (searchName) {
    param.append("searchName", searchName || "All States");
  }
  if (marketingPhase) {
    param.append("previewProperty", "Y");
  }
  if (nobuyerpremium) {
    param.append("noBuyerPremiumFilter", "Y");
  }
  if (brokerCoOp) {
    param.append("brokerCoOp", "Y");
  }
  if (listingType && listingType === "TRNL") {
    param.append("listingType", "TRNL");
  }
  if (newToHubzu) {
    param.append("newToHubzu", "Y");
  }
  if (auctionEndingToday) {
    param.append("auctionEndingToday", "Y");
  }
  if (cashOnly) {
    param.append("cashOnly", "Y");
  }

  if (category.length > 0) {
    param.append("category", category);
  }
  if (propertyStatus.length > 0) {
    param.append("propertyStatus", propertyStatus);
  }
  if (occupancyStatus.length > 0) {
    param.append("occupancyStatus", occupancyStatus);
  }
  if (sid.length > 0) {
    param.append("sid", sid);
  }
  if (propertyShowMoreStatus.length > 0) {
    param.append("propertyStatus", propertyShowMoreStatus);
  }
  if (ownItNow) {
    param.append("ownItNow", "Y");
  }
  // if (campaign) {
  //   param.append("campaign", [campaign]);
  // }
  // if (campaignId) {
  //   param.append("campaignId", [campaignId]);
  // }
  // if (campaignType) {
  //   param.append("campaignType", [campaignType]);
  // }
  // if (isPartOfCampaign) {
  //   param.append("isPartOfCampaign", [isPartOfCampaign]);
  // }
  // if (offers) {
  //   param.append("offers", [offers]);
  // }
  switch (pathname) {
    case '/bank-owned':
      param.append("category", 'bankowned');
      break;
    // case '/auctions?sid=signature-seller':
    //   param.sid = ['signature-seller'];
    //   break;
    // case '/offmarket':
    //   param.sid = ['offmarket-properties'];
    //   break;
    case '/foreclosures':
      param.append("listingType", 'AUCN');
      param.append("category", 'foreclosure');
      break;
    case '/short-sale':
      param.append("listingType", 'AUCN');
      param.append("category", 'SHRT_SALE');
      break;
    case '/traditional-sale':
      param.append("listingType", 'TRNL');
      break;
    default:
     // param.listingType = ['AUCN'];
      break;
  }
  return param;
};

export const formUrl = (savedItem) => {
  const searchCriteria = savedItem?.searchCriteriaList || []
  try {
    //const context = window.contextPath || ''; // assumes global contextPath
    const params = new URLSearchParams();

    // Defaults
    // if (typeof isEnableNewSrp === 'undefined' || isEnableNewSrp !== 'Y') {
    //   params.append('searchBy', savedItem.searchBy || 'All States');
    // }

    // Helper to handle range values
    const addRangeParam = (key, min, max, defaultMax, label) => {
      if (min || max) {
        if (!min) params.append(key, `0-${max}`);
        else if (!max) params.append(key, `${min}-${defaultMax}`);
        else params.append(key, `${min}-${max}`);
      }
    };

    const multiValueParam = (key, value) => {
      value.split(',').forEach(val => params.append(key, val));
    };

    // Initialize variables for category logic
    let occupyStatus = '';
    let categoryREO = false;

    // Store individual values
    const values = {};

    // Loop through all search criteria
    for (const { criteriaKey, criteriaValue } of searchCriteria) {
      if (!criteriaValue) continue;
      values[criteriaKey] = criteriaValue;

      switch (criteriaKey) {
        case 'sid':
          criteriaValue.split(',').forEach(val => params.append('sid', val));
          break;

        case 'propertySubType':
        case 'propertyStatus':
        case 'propertyShowMoreStatus':
        case 'listingType':
          multiValueParam(criteriaKey, criteriaValue);
          break;

        case 'category':
          const catTypes = criteriaValue.split(',');
          for (const val of catTypes) {
            switch (val) {
              case 'SHRT_SALE':
              case 'NON_REO':
              case 'bankowned(occupied)':
              case 'bankowned(nonoccupied)':
              case 'nonbankowned(occupied)':
              case 'nonbankowned(nonoccupied)':
              case 'foreclosure':
              case 'bankowned':
              case 'sid':
              case 'nonbankowned':
              case 'commercial':
              case 'secondchance':
                params.append('category', val);
                break;
              case 'REO':
                categoryREO = true;
                break;
            }
          }
          break;

        case 'occupancyStatus':
          occupyStatus = criteriaValue;
          criteriaValue.split(',').forEach(val => {
            if (val === 'Y' || val === 'N') params.append('occupancyStatus', val);
          });
          break;
        case 'propertyShowMoreStatus':
          multiValueParam(criteriaKey, criteriaValue);

        case 'sortBy':
          params.append(criteriaValue, '');
          break;

        case 'rectSrchFlag':
          params.append('rect', 'true');
          break;

        case 'neLatLng':
        case 'swLatLng':
          params.append(criteriaKey, criteriaValue);
          break;

        case 'centerLatLng':
          params.append('centerPoint', criteriaValue);
          break;

        case 'zoomValue':
        case 'view':
        case 'latitude':
        case 'longitude':
          params.append(criteriaKey, criteriaValue);
          break;

        case 'previewProperty':
          params.append('marketingPhase', criteriaValue);
          break;

        case 'noBuyerPremiumFilter':
          params.append('nobuyerpremium', criteriaValue);
          break;

        case 'reservepricerevealed':
          params.append('reservepricerevealed', criteriaValue);
          break;

        case 'selfshowingenabled':
          params.append('selfshowingenabled', criteriaValue);
          break;

        case 'brokerCoOp':
          params.append('brokerCoOp', criteriaValue);
          break;

        case 'newToHubzu':
          params.append('newToHubzu', criteriaValue);
          break;

        case 'auctionEndingToday':
          params.append('auctionEndingToday', criteriaValue);
          break;

        case 'cashOnly':
          params.append('cashOnly', criteriaValue);
          break;

        default:
          // No-op for others (used below)
          break;
      }
    }

    // Price, sqft, year built ranges
    addRangeParam('priceRange', values.minPriceValue, values.maxPriceValue, '1000000plus');
    addRangeParam('squareFeetRange', values.minPropertySize, values.maxPropertySize, '10000plus');
    addRangeParam('yearBuiltRange', values.minYearBuilt, values.maxYearBuilt, 'After 2010');

    // Bed and Bath
    if (values.bed) params.append('bed', parseInt(values.bed));
    if (values.bath) params.append('bath', parseInt(values.bath));

    // Handle ownItNow override
    if (values.ownItNow === 'Y') {
      params.append('listingType', 'AUCN');
      params.append('ownItNow', 'Y');
      if (![...params.keys()].includes('propertyStatus')) {
        params.append('propertyStatus', 'ACTIVE');
      }
    }

    // Handle REO logic
    if (categoryREO) {
      if (occupyStatus.includes('Y')) params.append('category', 'bankowned(occupied)');
      if (occupyStatus.includes('N')) params.append('category', 'bankowned(nonoccupied)');
    }

    // Final URL
    const base = savedItem.baseSearchUrl || 'searchResult';
    return `/${base}?${params.toString()}`;
  } catch (e) {
    console.error('Error building URL:', e);
    return '';
  }
};

const criteriaLabelMap = {
  PRICE_RANGE: "Price",
  SQFT_RANGE: "Sq. Feet",
  YEAR_BUILT: "Year Built",
  auctionEndingToday: "Listing Status",
  bankOwned: "Bank Owned",
  bath: "Bathroom",
  bed: "Bedroom",
  brokerCoOp: "Featured",
  cashOnly: "Featured",
  category: "Listing Type",
  listingType: "Sales Type",
  newToHubzu: "Listing Status",
  noBuyerPremiumFilter: "Featured",
  nonBankOwned: "Non-Bank Owned",
  nonOccupied: "Non Occupied",
  npl: "Non Performing Loan",
  occupancyStatus: "Occupancy Status",
  occupied: "Occupied",
  orderBy: "Order By",
  ownItNow: "End the Auction Now",
  previewProperty: "Listing Type",
  propertyShowMoreStatus: "Show Only",
  propertyStatus: "Listing Status",
  propertySubType: "Property Type",
  reservepricerevealed: "Featured",
  selfshowingenabled: "Featured",
  sortBy: "Sort By",
  sortOrder: "Sort Order"
};

const rangeLabels = {
  PRICE_RANGE: {
    above: "Above",
    below: "Below",
  },
  YEAR_BUILT: {
    before: "Before",
    after: "After",
  },
  SQFT_RANGE: {
    greaterThan: "Greater than",
    lessThan: "Less than",
  },
};
const getRange = (minVal, maxVal, identifier) => {
  let range = "";

  if (minVal && maxVal) {
    range = `${minVal} - ${maxVal}`;
  } else if (!minVal) {
    const label = rangeLabels[identifier]?.below || "Below";
    range = `${label} ${maxVal}`;
  } else {
    const label = rangeLabels[identifier]?.above || "Above";
    range = `${label} ${minVal}`;
  }

  return {
    criteriaKey: identifier,
    criteriaValue: range,
  };
};

export const formDescription = (savedItem) => {
  const criteriaList = savedItem?.searchCriteriaList || [];
  let minPrice = "", maxPrice = "", minSqrFt = "", maxSqrFt = "";
  let minYearBuilt = "", maxYearBuilt = "";

  const updatedCriteria = [];
  const propertyStatusMap = new Map();
  criteriaList.forEach((criteria) => {
    const { criteriaKey, criteriaValue, criteriaValueDescription } = criteria;

    switch (criteriaKey) {
      case "minPriceValue":
        minPrice = criteriaValue;
        break;

      case "maxPriceValue":
        maxPrice = criteriaValue;
        break;

      case "minPropertySize":
        minSqrFt = criteriaValue;
        break;

      case "maxPropertySize":
        maxSqrFt = criteriaValue;
        break;

      case "minYearBuilt":
        minYearBuilt = criteriaValue;
        break;

      case "maxYearBuilt":
        maxYearBuilt = criteriaValue;
        break;

      case "bath":
      case "bed":
        updatedCriteria.push({
          criteriaKey,
          criteriaValue: `${criteriaValue}+`,
          criteriaLabel: criteriaLabelMap[criteriaKey] || criteriaKey,
        });
        break;

      case "previewProperty":
      case "noBuyerPremiumFilter":
      case "reservepricerevealed":
      case "selfshowingenabled":
      case "brokerCoOp":
      case "cashOnly":
        updatedCriteria.push({
          criteriaKey,
          criteriaValue: criteriaValueDescription,
          criteriaLabel: criteriaLabelMap[criteriaKey] || criteriaKey,
        });
        break;

      case "newToHubzu":
      case "auctionEndingToday":
        const existing = propertyStatusMap.get("propertyStatus") || [];
        existing.push(criteriaValueDescription);
        propertyStatusMap.set("propertyStatus", existing);
        break;

      case "occupancyStatus":
        const occupancyVal = criteriaValue.split(",").map(val =>
          val === "Y" ? "Occupied" : "Non Occupied"
        );
        updatedCriteria.push({
          criteriaKey,
          criteriaValue: occupancyVal.join(", "),
          criteriaLabel: criteriaLabelMap[criteriaKey] || criteriaKey,
        });
        break;

      default:
        if (!["rectSrchFlag", "neLatLng", "swLatLng", "centerLatLng", "zoomValue", "view", "latitude", "longitude"].includes(criteriaKey)) {
          updatedCriteria.push({
            criteriaKey,
            criteriaValue: criteriaValueDescription || criteriaValue,
            criteriaLabel: criteriaLabelMap[criteriaKey] || criteriaKey,
          });
        }
    }
  });

  // Push propertyStatus combined values
  if (propertyStatusMap.has("propertyStatus")) {
    updatedCriteria.push({
      criteriaKey: "propertyStatus",
      criteriaValue: propertyStatusMap.get("propertyStatus").join(", "),
      criteriaLabel: criteriaLabelMap['propertyStatus'] || 'propertyStatus',
    });
  }

  // Add derived range fields
  if (minPrice || maxPrice) {
    const range = getRange(minPrice || "$0", maxPrice, "PRICE_RANGE");
    range.criteriaLabel = criteriaLabelMap["PRICE_RANGE"];
    updatedCriteria.push(range);
  }

  if (minYearBuilt || maxYearBuilt) {
    const yearRange = getRange(minYearBuilt || "Before 1800", maxYearBuilt || "After 2010", "YEAR_BUILT");
    yearRange.criteriaLabel = criteriaLabelMap["YEAR_BUILT"];
    updatedCriteria.push(yearRange);
  }

  if (minSqrFt || maxSqrFt) {
    const sqftRange = getRange(minSqrFt || dUtil.formatSqFt("0"), maxSqrFt, "SQFT_RANGE");
    sqftRange.criteriaLabel = criteriaLabelMap["SQFT_RANGE"];
    updatedCriteria.push(sqftRange);
  }

  let fullDescription = "";
  updatedCriteria.reverse().map(criteria => {
    fullDescription = fullDescription + (fullDescription ? ", " : "")  + criteria.criteriaValue;
  })
  let allDesription = fullDescription.split(', ');
  let shortDesription = allDesription.length > 3 ? allDesription[0] + ", " + allDesription[1] + ", " + allDesription[2] + ", " + `+${allDesription.length - 3} More` : fullDescription;

  return shortDesription;
};